import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=64606872&scoped=true"
import script from "./HomeHeader.vue?vue&type=script&lang=ts"
export * from "./HomeHeader.vue?vue&type=script&lang=ts"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&id=64606872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64606872",
  null
  
)

export default component.exports